const CUSTOMER_COUNT = [
  {
    id: 1,
    name: "Total Happy Customers",
    count: 100000,
  },
  {
    id: 2,
    name: "Daily Customers",
    count: 1000,
  },
];

export default CUSTOMER_COUNT;
